import React  from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button, notification, Popconfirm } from 'antd';
import { removeLiftoffUser } from '../../api/liftoffUserApi';

const RemoveUserButton = ({ user, onComplete, style}) => {
  const showError = message => {
    notification.error({
      message: 'Create User Failed',
      description: message,
      placement: 'bottomRight',
    });
  };

  const remove = async () => {
    try {
      const { status } = await removeLiftoffUser(user.email);
      if (status === 200) {
        notification.success({
          message: 'Success',
          description: `${user.email} has been removed as a Liftoff User!`,
          placement: 'bottomRight',
        });
        onComplete();
      } else {
        showError(`User ${user.email} could not be removed. Please contact na_opsenablement@credera.com`);
      }
    } catch (e) {
      showError(`User ${user.email} could not be created. Please contact na_opsenablement@credera.com. Error: ${e.message}`);
    }
  };

  return (
    <Popconfirm
      title={`Are you sure to remove ${user.email}?`}
      onConfirm={remove}
      okText="Yes"
      cancelText="No"
    >
      <Button icon={<DeleteOutlined />} style={style}>Remove</Button>
    </Popconfirm>
  );
};

export { RemoveUserButton };